import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INTEREST_OPTIONS } from "@/lib/api";

export default function GetInvolvedCta() {
  return (
    <section
      id="get-involved"
      data-testid="get-involved-cta-section"
      className="border-r-0 lg:border-r hairline p-8 md:p-12 lg:p-16 bg-white relative overflow-hidden"
    >
      <div className="max-w-xl">
        <div data-testid="get-involved-cta-section-label" className="font-mono-label text-[11px] text-[#0F1117] mb-6">
          / Get involved
        </div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight font-extrabold text-[#0F1117] text-balance mb-4">
          Tell us where you fit.
        </h2>
        <p className="text-[15px] text-[#52555B] leading-relaxed mb-10">
          {"Partnership, collaboration, sponsorship, hiring, training, community, funding — unlimited ways to plug in. One form. We'll route you to the right person on our side."}
        </p>

        {/* Interest tags preview */}
        <div className="grid grid-cols-2 gap-px bg-[#D2D5DA] border hairline mb-10">
          {INTEREST_OPTIONS.map((opt) => (
            <div
              key={opt.value}
              className="chrome-tile px-4 py-3 text-sm text-[#0F1117] flex items-center gap-2.5"
            >
              <span className="w-1.5 h-1.5 chrome-bar" aria-hidden />
              <span className="font-medium">{opt.label}</span>
            </div>
          ))}
        </div>

        <Link
          to="/get-involved"
          data-testid="open-get-involved-page-btn"
          className="chrome-btn-dark group inline-flex items-center gap-2 font-mono-label text-[12px] px-6 py-4"
        >
          Open the Get Involved form
          <ArrowUpRight
            size={16}
            className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </Link>

        <p className="mt-6 font-mono-label text-[10px] text-[#71747B] max-w-md">
          Takes under a minute. We reply quickly.
        </p>
      </div>
    </section>
  );
}
